var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyboardEnter = function SvgKeyboardEnter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1.088.996H3.245l2.5 2.293a.998.998 0 0 1 0 1.408 1.001 1.001 0 0 1-1.435 0L.44 11.057a1.497 1.497 0 0 1 0-2.119L4.29 5.293a1.026 1.026 0 0 1 1.436 0 .999.999 0 0 1 0 1.413L3.24 8.998H14V3h-3a1 1 0 1 1 0-2h4Z"
  })));
};
export default SvgKeyboardEnter;